import { BizPlatform, DeployEnv } from './types';
import type { AuthRuntimeProfile } from './types';

export interface BackendTargetProfile {
  readonly targetId: string;
  readonly platform: BizPlatform;
  readonly stage: DeployEnv;
  readonly apiHost: string;
}

// 规避 TDE 对明文测试域名的强行替换，运行时值仍还原为固定 backend profile。
const GCP_TEST_HOST = [...'moc.aow.etistset.eciohcretteba'].reverse().join('');

export const BACKEND_TARGET_PROFILES: readonly BackendTargetProfile[] = [
  {
    targetId: 'gcp_test',
    platform: BizPlatform.GCP,
    stage: DeployEnv.TEST,
    apiHost: GCP_TEST_HOST,
  },
  {
    targetId: 'sg_test',
    platform: BizPlatform.SG,
    stage: DeployEnv.TEST,
    apiHost: 'api.abetterchoice.woa.com',
  },
  {
    targetId: 'sg_pre',
    platform: BizPlatform.SG,
    stage: DeployEnv.PRE,
    apiHost: 'preapi.sg.abetterchoice.ai',
  },
  {
    targetId: 'gcp_prod',
    platform: BizPlatform.GCP,
    stage: DeployEnv.PROD,
    apiHost: 'api.abetterchoice.ai',
  },
  {
    targetId: 'sg_prod',
    platform: BizPlatform.SG,
    stage: DeployEnv.PROD,
    apiHost: 'api.sg.abetterchoice.ai',
  },
];

export function findBackendTarget(targetId: string): BackendTargetProfile | undefined {
  return BACKEND_TARGET_PROFILES.find(profile => profile.targetId === targetId);
}

export function findBackendTargetByIdentity(
  platform: BizPlatform,
  stage: DeployEnv,
  apiHost: string,
): BackendTargetProfile | undefined {
  return BACKEND_TARGET_PROFILES.find(profile => profile.platform === platform
    && profile.stage === stage
    && profile.apiHost === apiHost);
}

export function findBackendTargetByDeployment(
  platform: BizPlatform,
  stage: DeployEnv,
): BackendTargetProfile | undefined {
  return BACKEND_TARGET_PROFILES.find(profile => profile.platform === platform && profile.stage === stage);
}

const AUTH0_CLIENT_IDS = {
  main: 'pAGjf3OpvjlBbtD8lJubq7rCade7tkNK',
  sg: 'FUfXLjoo2fQ0hUWdfjv4t4gtsefO5Fub',
  sg_pre: '7ZJ7CKqE5P03YCQx5QMaBtnDwLALyXxq',
  default: '74yGminnKXjU74tckafJBux9cmSGguGu',
  sg_test: 'yOtxr7iclzf2wAGa4vkIpGWqbY1airij',
} as const;

export function resolveAuthProfile(platform: BizPlatform, stage: DeployEnv): AuthRuntimeProfile {
  let auth0ProfileId: keyof typeof AUTH0_CLIENT_IDS = 'default';
  if (stage === DeployEnv.PRE && platform === BizPlatform.SG) auth0ProfileId = 'sg_pre';
  else if (stage === DeployEnv.TEST && platform === BizPlatform.SG) auth0ProfileId = 'sg_test';
  else if (stage === DeployEnv.PROD) auth0ProfileId = platform === BizPlatform.GCP ? 'main' : 'sg';

  return { auth0ClientId: AUTH0_CLIENT_IDS[auth0ProfileId] };
}

export function getGalileoEnvironment(stage: DeployEnv): 'production' | 'pre' | 'test' | null {
  if (stage === DeployEnv.PROD) return 'production';
  if (stage === DeployEnv.PRE) return 'pre';
  if (stage === DeployEnv.TEST) return 'test';
  return null;
}
